function MainTitle(props: any) {
  return (
    <header className="mt-4">
      {/* Big title */}
      <h2 className="mb-6 font-title text-6xl font-semibold leading-none tracking-wider text-gray-700">
        {props.title}
      </h2>
    </header>
  )
}

export default MainTitle
